import styled from "styled-components"
const Wrapper = styled.div`
    height : calc(100vh - 180px);
    display : flex;
    align-items : center;
    justify-content : center;
    gap : 30px;
    flex-direction : column;
    padding : 100px 0;
    box-sizing : border-box;
`

export default Wrapper